import { StateCreator } from "zustand";

export interface SectionSlice {
  selectedSectionZustand: string | null;

  setSelectedSectionZustand: (section: string) => void;
}

export const createSectionSlice: StateCreator<SectionSlice> = (
  set: any,
  get: any
) => {
  return {
    selectedSectionZustand: "Parametrizacoes",
    setSelectedSectionZustand(section) {
      set({
        selectedSectionZustand: section,
      });
    },
  };
};
